export class DigitCounter {
  constructor(element, config = {}) {
    this.element = element;
    this.originalText = element.textContent.trim();

    this.hasPercentage = this.originalText.includes('%');
    this.targetValue = parseInt(this.originalText);

    const defaultConfig = {
      duration: 1000,
      easing: 'easeOutQuad',
      intersectionThreshold: 0.2,
      intersectionRootMargin: '50px',
      startDelay: 0
    };

    this.config = { ...defaultConfig, ...config };
    this.hasAnimated = false;

    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: this.config.intersectionRootMargin,
      threshold: this.config.intersectionThreshold
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated) {
          setTimeout(() => {
            this.animate();
          }, this.config.startDelay);
          this.hasAnimated = true;
          this.observer.disconnect();
        }
      });
    }, options);

    this.observer.observe(this.element);
  }

  animate() {
    const startValue = 0;
    const startTime = performance.now();

    const updateCounter = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.config.duration, 1);

      const easedProgress = this[this.config.easing](progress);

      const currentValue = Math.round(startValue + (this.targetValue - startValue) * easedProgress);

      this.element.textContent = this.hasPercentage ? `${currentValue}%` : currentValue;

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    };

    requestAnimationFrame(updateCounter);
  }

  // Easing functions
  easeOutQuad(t) {
    return t * (2 - t);
  }

  easeLinear(t) {
    return t;
  }

  easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  dispose() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.observer = null;
    this.element = null;
  }
}
